import { takeLatest, call, put, all, select } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/rotasp/api';
import { PATH_IIRGD_BU_PPT } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, LibracaoCiliRequest } from './types';

// ACTIONS
import { libracaoCiliSuccess, libracaoCiliFailure } from './actions';

function* libracaoCiliRequest(request: ReducerActionRotaSP) {
	const { payload }: { payload: LibracaoCiliRequest } = request;
	const { usuario, ...rest } = payload;

	const newPayload = rest;
	newPayload.registroDigito = newPayload.registroDigito.trim();
	newPayload.registroDigito = newPayload.registroDigito.substring(0, 1);
	newPayload.registroSequencia =
		newPayload.registroSequencia?.substring(0, 2) ?? '1';

	const token: string = yield select(state => state.user.token.data);

	const response: ApiResponse = yield call(
		postApi as any,
		token || '',
		PATH_IIRGD_BU_PPT,
		'liberacao-simplificada',
		newPayload,
		{ usuario: usuario ? usuario.toUpperCase() : '' },
	);

	if (response.status === 200 || response.status === 204) {
		yield put(libracaoCiliSuccess(response));
	} else {
		yield put(libracaoCiliFailure(response));
	}
}
export default all([
	takeLatest(Types.LIBERACAO_CILI_REQUEST, libracaoCiliRequest),
]);
